const w = (window as any) ?? {};

const proto =
  w.VITE_API_PROTOCOL ?? import.meta.env.VITE_API_PROTOCOL ?? "http";
const host = w.VITE_API_HOST ?? import.meta.env.VITE_API_HOST ?? "localhost";
const port = w.VITE_API_PORT ?? import.meta.env.VITE_API_PORT ?? "3000";
const typicalPort =
  (proto == "http" && port == "80") || (proto == "https" && port == "443");
const portString = `${typicalPort ? "" : `:${port}`}`;
const rootPath = w.VITE_API_PATH ?? import.meta.env.VITE_API_PATH ?? "";

//window.location.host

export const API_BASE_URL = window.location.origin + "/api"; //`${proto}://${host}${portString}${rootPath}/`;

export function constructQueryString(params: Record<string, any>): string {
  return Object.keys(params)
    .filter((key) => params[key] !== undefined)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join("&");
}
